import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.333 5.333A1.333 1.333 0 0 0 12 4H4a1.33 1.33 0 0 0-1.333 1.333v5.333A1.335 1.335 0 0 0 4 12h8a1.333 1.333 0 0 0 1.333-1.334zm1.334 5.333A2.67 2.67 0 0 1 12 13.333H4a2.667 2.667 0 0 1-2.667-2.667V5.333A2.667 2.667 0 0 1 4 2.666h8a2.667 2.667 0 0 1 2.667 2.667z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.3 8.11a.67.67 0 0 1 .838.085l2 2 .085.104a.667.667 0 0 1-.924.924l-.104-.085L6.667 9.61l-1.529 1.528a.667.667 0 0 1-.943-.943l2-2z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.344 6.002C9.222 6.007 10 6.739 10 7.667c0 .607-.427 1.032-.763 1.26-.354.24-.815.407-1.237.407H5.333c-.422 0-.883-.168-1.237-.408-.336-.227-.763-.652-.763-1.26 0-.927.777-1.658 1.655-1.664h.008L5 6c.632-.007 1.152.328 1.524.78q.074.09.142.188.069-.098.143-.188c.372-.452.892-.786 1.524-.78h.012zM5 7.334a.35.35 0 0 0-.332.319q.003.007.012.02a.6.6 0 0 0 .163.149c.18.122.386.178.49.179h.398a2 2 0 0 0-.236-.374c-.2-.243-.369-.295-.483-.293zm3.321 0c-.114-.002-.282.05-.482.293q-.124.15-.237.374H8c.104 0 .31-.057.49-.18a.6.6 0 0 0 .163-.148q.01-.015.012-.022a.35.35 0 0 0-.332-.317z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })